import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'hf-custom-checkbox',
  templateUrl: './custom-checkbox.component.html',
  styleUrls: ['./custom-checkbox.component.scss']
})
export class CustomCheckboxComponent implements OnInit {
  @Input() public isFormGroup: boolean;
  @Input() public label: string;
  @Input() public checkboxFormControl: AbstractControl;
  @Input() public isDisabled?: boolean;
  @Input() public model?: boolean;
  @Input() public smallLabel?: boolean;
  /** Optional description text */
  @Input() description?: string;

  /** Optional outer layer style */
  @Input() outerLayer?: boolean = false;

  @Output() public onCheckedChange: EventEmitter<boolean> = new EventEmitter();
  @Output() public modelChange = new EventEmitter<boolean>();

  get isChecked(): boolean {
    if (this.isFormGroup) return !!this.checkboxFormControl?.value;
    return !!this.model;
  }

  ngOnInit(): void {
    if (this.isDisabled && this.checkboxFormControl instanceof UntypedFormControl) {
      this.checkboxFormControl.disable();
    }
  }

  public onClicked(): void {
    if (this.checkboxFormControl instanceof UntypedFormControl) {
      const newValue = this.checkboxFormControl.value;
      this.checkboxFormControl.setValue(newValue);
      this.checkboxFormControl.markAsTouched();
      this.onCheckedChange.emit(newValue);
    }
  }
}
